import React from 'react';
import { Tag } from '@carbon/react';
import {
  getGatewayProductFamily,
  getGatewayModelDisplay,
  getGatewayProductTagType,
} from '../utils/gatewayProductLabel';

const GatewayTypeTags = ({ gateway, showSource = true }) => {
  const family = getGatewayProductFamily(gateway);
  const model = getGatewayModelDisplay(gateway);

  return (
    <div style={{ display: 'flex', gap: '4px', alignItems: 'center', flexWrap: 'wrap' }}>
      <Tag type={getGatewayProductTagType(family)} size="sm">{family}</Tag>
      {model && model !== family ? (
        <Tag type="outline" size="sm">{model}</Tag>
      ) : null}
      {showSource && gateway?.source ? (
        <Tag type={gateway.source === 'mqtt' ? 'purple' : 'cyan'} size="sm">
          {gateway.source.toUpperCase()}
        </Tag>
      ) : null}
    </div>
  );
};

export default GatewayTypeTags;
